import { Box, Card, Skeleton, Stack, Typography } from '@mui/material';
import React from 'react';

///////////////////////////////////////////////////////////////////////////////

export const GeneralIndicatorCardLoading = () => {
    return (
        <Card sx={{ width: 300, height: 105 }} elevation={1}>
            <Box
                width="100%"
                height="100%"
                paddingLeft={1}
                sx={
                    {
                        borderLeftWidth: 12,
                        borderLeftStyle: "solid",
                        borderLeftColor: "muted.main",
                        color: "muted.main"
                    }
                }
            >
                <Stack direction="row" alignItems="flex-start" width="100%" spacing={1}>
                    <Typography fontSize="24" component="div">
                        <Skeleton width={60} height={48} /> 
                    </Typography>
                    <Stack direction="column" justifyContent="center" height="inherit">
                        <Typography fontSize="14" component="div" textTransform="uppercase">
                            <Skeleton width={200} height={48} /> 
                        </Typography>
                        <Typography fontSize="12" component="div">
                            <Skeleton width={200} height={28} /> 
                        </Typography>
                    </Stack>
                </Stack>
            </Box>
        </Card>
    );
}

